import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Row } from 'react-bootstrap';
import moment from 'moment';
import { createNewSortedLogEntryArray } from '../utils/sorting';
import roles from '../utils/roles';
import DurationFormatter from '../utils/duration';

import DeleteConfirmationModal from './DeleteConfirmationModal';
import NewLogEntryWidget from './NewLogEntryWidget';
import ShowPill from './ShowPill';

import * as logEntryActions from '../actions/logEntryActionCreators';

class LogEntryDayListWidget extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.logEntryRef = [];

        if (this.props.getDay) this.props.getDay(this);

        let logEntries = createNewSortedLogEntryArray(this.props.logEntries);
        let deleteConfirmationModal =
            (<DeleteConfirmationModal
                returnKeymaster={this.props.returnKeymaster}
                handleClose={this.handleHideDeleteConfirmation}
                handleConfirm={this.deleteAllLogEntries}
                />);

        this.state = {
            createLogEntry: false,
            deleteConfirmationModal: deleteConfirmationModal,
            logEntries: logEntries,
            showDeleteConfirmation: false
        };
    }

    // LIFECYCLE METHODS
    componentWillReceiveProps = (nextProps) => {
        let logEntries = createNewSortedLogEntryArray(nextProps.logEntries);

        this.setState({ logEntries: logEntries });
    }

    // EVENT HANDLERS

    handleDragOver = (dragEvent) => { dragEvent.preventDefault(); }

    handleDrop = (dropEvent) => {
        let data = JSON.parse(dropEvent.dataTransfer.getData("application/json"));
        dropEvent.preventDefault();
        let targetDate = this.props.date.format("YYYY-MM-DD");

        // don't do anything if we're dragging it to the same date
        if (data.date === targetDate) return;

        // check if user has access to the task associated
        let canModify = this._checkIfUserCanModifyTask(data);

        if (!canModify) return;

        data.date = targetDate;

        // update the lastModifiedAt field because we are either moving it
        // ergo updating or copying at which point the copy should have the
        // newer timestamp
        data.lastModifiedAt = moment().format("YYYY-MM-DD[T]H:mm:ss");

        if (this.props.currentUser) {
            data.lastModifiedByUser = this.props.currentUser.givenName + " " + this.props.currentUser.surname + " (" + this.props.currentUser.username + ")";
        }

        if (this.props.pmoMode){
            // append the user we are editing for
            data.userID = this.props.user.id;

            if (dropEvent.dataTransfer.effectAllowed === "copy" || dropEvent.metaKey || dropEvent.ctrlKey) {
                dropEvent.dataTransfer.dropEvent = "copy";
                data.id = null;
                this.props.dispatch(logEntryActions.pmoCreate(data));
            } else {
                dropEvent.dataTransfer.dropEvent = "move";
                this.props.dispatch(logEntryActions.pmoUpdate(data));
            }
        } else {
            data.status = "DRAFT";

            if (this.props.currentUser) data.userID = this.props.currentUser.id;

            if (dropEvent.dataTransfer.effectAllowed === "copy" || dropEvent.metaKey || dropEvent.ctrlKey) {
                dropEvent.dataTransfer.dropEvent = "copy";
                data.id = null;
                this.props.dispatch(logEntryActions.create(data));
                this.props.loadTimesheet();
                if (this.props.handleLogEntryEvent) {
                    this.props.handleLogEntryEvent();
                }
            } else {
                dropEvent.dataTransfer.dropEvent = "move";
                if (data.pmoApproverUser) //if it had been approved by PMO, user can't move it
                    return;

                this.props.dispatch(logEntryActions.update(data));
                this.props.loadTimesheet();
            }
        }
    }

    handleHideDeleteConfirmation = () => { this.setState({ showDeleteConfirmation: false });}

    handleShowDeleteConfirmation = () =>  { this.setState({ showDeleteConfirmation: true }); }

    // OTHER METHODS

    _checkIfUserCanModifyTask (data){
        let canModify = false;

        for (let i = 0; i < this.props.tasks.length; ++i) {
            // match task id so we know it is assigned to the user
            if ((this.props.tasks[i].taskID == data.taskID)
                || this.props.tasks[i].id == data.taskID) {

                // no end date so just check if the target date is same or after the start date
                if (this.props.tasks[i].projectStartDate
                    && !this.props.tasks[i].projectEndDate
                    && (this.props.date.isSame(this.props.tasks[i].projectStartDate)
                        || this.props.date.isAfter(this.props.tasks[i].projectStartDate))) {
                    canModify = true;
                    break;
                }

                // we have both start and end dates so compare if the target date is between
                if (this.props.tasks[i].projectStartDate
                    && this.props.tasks[i].projectEndDate
                    && (this.props.date.isSame(this.props.tasks[i].projectStartDate)
                        || this.props.date.isAfter(this.props.tasks[i].projectStartDate))
                    && (this.props.date.isSame(this.props.tasks[i].projectEndDate)
                        || this.props.date.isBefore(this.props.tasks[i].projectEndDate))) {
                    canModify = true;
                    break;
                }

                // this is a floating task
                if (!this.props.tasks[i].projectStartDate && !this.props.tasks[i].projectEndDate)
                    canModify = true;

                break;
            }
        }

        return canModify;
    }

    closePopovers = () => {
        for (let i = 0; i < this.logEntryRef.length; ++i) {
            let logEntry = this.logEntryRef[i];

            if (logEntry.handlePopoverClose) {
                logEntry.handlePopoverClose();
            }
        }
    }

    copyAllLogEntries = () => {
        this.props.pmoMode ? this.copyEntry_pmo(0) : this.copyEntry_user(0);

        if (this.props.handleLogEntryEvent) {
            setTimeout(this.props.handleLogEntryEvent, 300);
        }
    }

    copyEntry_pmo = (logEntryIndex) => {
        if (logEntryIndex >= this.state.logEntries.length)
            return;

        if (this.state.logEntries[logEntryIndex].timer == true)
            return;

        let original = this.state.logEntries[logEntryIndex];
        let copy = JSON.parse(JSON.stringify(original));
        copy.date = moment(this.props.date.format("YYYY-MM-DD"), "YYYY-MM-DD");
        copy.date.add(1, 'days');
        copy.date = copy.date.format("YYYY-MM-DD");

        if (!copy.taskID) copy.taskID = original.taskID;

        copy.userID = this.props.user.id;

        //we want to create a new logEntry, with its own ID
        copy.id = null;

        copy.status = "ACCEPTED";

        this.props.dispatch(logEntryActions.pmoCreate(copy));

        setTimeout(this.copyEntry_pmo.bind(this, logEntryIndex + 1), 100);
    }

    copyEntry_user = (logEntryIndex) => {
        if (logEntryIndex >= this.state.logEntries.length) {
            this.props.loadTimesheet();
            return;
        }

        if (this.state.logEntries[logEntryIndex].timer === true)
            return;

        let original = this.state.logEntries[logEntryIndex];
        let copy = JSON.parse(JSON.stringify(original));

        copy.date = moment(this.props.date.format("YYYY-MM-DD"), "YYYY-MM-DD");
        copy.date.add(1, 'days');
        copy.status = "DRAFT";

        if (!copy.taskID) copy.taskID = original.taskID;

        copy.userID = this.props.currentUser.id;

        //we want to create a new logEntry, with its own ID
        copy.id = null;

        if (this.props.currentUser) {
            copy.lastModifiedByUser = this.props.currentUser.givenName + " " + this.props.currentUser.surname + " (" + this.props.currentUser.username + ")";
        }

        let canCopy = false;

        for (let i = 0; i < this.props.tasks.length; ++i) {
            // match task id so we know it is assigned to the user
            if ((this.props.tasks[i].id == copy.taskID)
                || this.props.tasks[i].id == copy.taskID) {

                // no end date so just check if the target date is same or after the start date
                if (this.props.tasks[i].projectStartDate
                    && !this.props.tasks[i].projectEndDate
                    && (copy.date.isSame(this.props.tasks[i].projectStartDate)
                        || copy.date.isAfter(this.props.tasks[i].projectStartDate))) {
                    canCopy = true;
                    break;
                }

                // we have both start and end dates so compare if the target date is between
                if (this.props.tasks[i].projectStartDate
                    && this.props.tasks[i].projectEndDate
                    && (copy.date.isSame(this.props.tasks[i].projectStartDate)
                        || copy.date.isAfter(this.props.tasks[i].projectStartDate))
                    && (copy.date.isSame(this.props.tasks[i].projectEndDate)
                        || copy.date.isBefore(this.props.tasks[i].projectEndDate))) {
                    canCopy = true;
                    break;
                }

                // this is a floating task
                if (!this.props.tasks[i].projectStartDate && !this.props.tasks[i].projectEndDate) {
                    canCopy = true;
                }

                break;
            }
        }

        copy.date = copy.date.format("YYYY-MM-DD");

        if (canCopy) this.props.dispatch(logEntryActions.create(copy));

        setTimeout(this.copyEntry_user.bind(this, logEntryIndex + 1), 100);
    }

    createLogEntry = (logEntry) => {
        if (!logEntry.date) {
            logEntry.date = this.props.date.format("YYYY-MM-DD");
        }

        if (this.props.pmoMode){
            logEntry.status = "ACCEPTED";
            this.props.dispatch(logEntryActions.pmoCreate(logEntry));
            this.toggleCreateLogEntry();
        } else {
            this.props.dispatch(logEntryActions.create(logEntry));
            this.toggleCreateLogEntry();
            setTimeout(this.props.loadTimesheet, 250);
            if (this.props.handleLogEntryEvent) {
                setTimeout(this.props.handleLogEntryEvent, 300);
            }
        }
    }

    deleteAllLogEntries = () => {
        if (this.props.pmoMode){
            for (let i = 0; i < this.state.logEntries.length; i++) {
                this.props.dispatch(logEntryActions.pmoDeleteEntry(this.state.logEntries[i].id));
            }
        } else {
            for (let i = 0; i < this.state.logEntries.length; i++) {
                if (this.state.logEntries[i].status === "ACCEPTED" || this.state.logEntries[i].status === "SUBMITTED") {
                    continue;
                }
                this.props.dispatch(logEntryActions.deleteEntry(this.state.logEntries[i].id));
            }
            this.props.loadTimesheet();
        }
    }

    toggleCreateLogEntry = () => {
        this.setState({
            createLogEntry: !this.state.createLogEntry
        }, () => {
            // close all popovers if we're going to show the create log entry modal dialog
            if (this.state.createLogEntry) {
                this.props.closeAllPopovers();
            }
        });
    }

    // RENDER METHOD

    render = () => {
        let regularTime = 0;
        let overtimeTime = 0;

        for (let i = 0; i < this.state.logEntries.length; ++i) {
            if (this.state.logEntries[i].timer)
                continue;

            if (this.state.logEntries[i].overtime) {
                overtimeTime += this.state.logEntries[i].duration;
            } else {
                regularTime += this.state.logEntries[i].duration;
            }
        }

        let panelClass = this.props.halfHeight ? "panel panel-day-calendar weekend" : "panel panel-day-calendar";

        if (this.props.odd) {
            panelClass = panelClass + " odd";
        }

        //TODO fillTaskForLogEntry is always NULL
        let createModal = ( this.props.pmoMode ?
            <NewLogEntryWidget
                createLogEntry={this.createLogEntry}
                date={this.props.date}
                infoUserTask={this.props.infoUserTask}
                onRequestHide={this.toggleCreateLogEntry}
                pmo={true}
                returnKeymaster={this.props.returnKeymaster}
                tasks={this.props.tasks}
                user={this.props.user}
                />
            :
            <NewLogEntryWidget
                createLogEntry={this.createLogEntry}
                date={this.props.date}
                editForUser={this.props.editForUser}
                infoUserTask={this.props.infoUserTask}
                onRequestHide={this.toggleCreateLogEntry}
                returnKeymaster={this.props.returnKeymaster}
                tasks={this.props.tasks}
                timesheet={this.props.timesheet}
                user={this.props.currentUser}
                />
        );

        return (
            <div className={panelClass}>
                {this.state.showDeleteConfirmation ? this.state.deleteConfirmationModal : null}
                {this.state.createLogEntry ? createModal : null}
                <div className="panel-heading">
                    <div className="panel-title clearfix">
                        <span style={{ "color": this.props.date.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD") ? "#cc2200" : "" }}>{this.props.date.format("dddd")}&nbsp;{this.props.date.format("DD.")}</span>
                        <div className="hours-title">
                            <span>{DurationFormatter.format(regularTime)}&nbsp;+&nbsp;<em>{DurationFormatter.format(overtimeTime)}</em></span>
                        </div>
                    </div>
                </div>
                <div className="panel-body tasks daily"  onDragOver={this.handleDragOver} onDrop={this.handleDrop}>
                    <div className="scrollable-div">
                        <ul>
                            {
                                this.props.pmoMode ?
                                this.state.logEntries.map((logEntry, i) => {
                                    return (<ShowPill
                                               closeAllPopovers={this.props.closeAllPopovers}
                                               draggable
                                               editForUser={this.props.user} //
                                               id={i}
                                               key={i}
                                               logEntry={logEntry}
                                               pmoMode={this.props.pmoMode}
                                               pmo={this.props.pmo} //
                                               returnKeymaster={this.props.returnKeymaster}
                                               smartPopoverPlacement
                                               tasks={this.props.tasks}
                                               timesheet={this.props.timesheet}
                                               getLog = {(yourself) => {this.logEntryRef[i] = yourself;}}
                                               />);
                                })
                                :
                                this.state.logEntries.map((logEntry, i) => {
                                    return (<ShowPill
                                               closeAllPopovers={this.props.closeAllPopovers}
                                               draggable
                                               id={i}
                                               key={i}
                                               logEntries={this.state.logEntries} //
                                               logEntry={logEntry}
                                               modalPopover={this.props.modalPopover} //
                                               returnKeymaster={this.props.returnKeymaster}
                                               smartPopoverPlacement
                                               tasks={this.props.tasks}
                                               timesheet={this.props.timesheet}
                                               getLog = {(yourself) => {this.logEntryRef[i] = yourself;}}
                                               />);
                                })
                            }
                        </ul>
                    </div>
                </div>

                <div className="panel-footer">
                    <div className={!this.props.isMobile ? "actions" : ""}>
                        {
                            (moment().subtract(1, 'months').isBefore(this.props.date) && (!this.props.timesheet || this.props.timesheet && (this.props.timesheet.status == "ENTRY" || this.props.timesheet.status == "FIXING")) || this.props.pmoMode)
                            ? <Row>
                                <button title="Add new work log" className="btn1 btn1-default btn1-centered" type="button" onClick={this.toggleCreateLogEntry}>New</button>
                                <span title="Delete all daily work logs" className="delete"><i onClick={this.handleShowDeleteConfirmation} className="md-delete md-lg"/></span>
                                {
                                    this.props.copyDisabled ? null :
                                    <span title="Copy into next day" className="copy"><i onClick={this.copyAllLogEntries} className="md-content-copy md-lg"/></span>
                                }
                            </Row>
                            : <Row style={{"height" : "35px"}}>
                                {
                                    <div style={{"margin":"-2px 25px"}}>Please contact Tashi Support if you wish to edit this day.</div>
                                }
                            </Row>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

LogEntryDayListWidget.propTypes = {
    closeAllPopovers: PropTypes.func,
    copyDisabled: PropTypes.bool,
    currentUser: PropTypes.object,
    date: PropTypes.object,
    dispatch: PropTypes.func,
    editForUser: PropTypes.object,
    getDay: PropTypes.func,
    handleLogEntryEvent: PropTypes.func,
    halfHeight: PropTypes.bool,
    infoUserTask: PropTypes.func,
    isMobile: PropTypes.bool,
    loadTimesheet: PropTypes.func,
    logEntries: PropTypes.array,
    modalPopover: PropTypes.bool,
    odd: PropTypes.bool,
    pmo: PropTypes.object,
    pmoMode: PropTypes.bool,
    returnKeymaster: PropTypes.func,
    tasks: PropTypes.array,
    timesheet: PropTypes.object,
    user: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        timesheet: state.timesheets.currentTimesheet,
        currentUser: state.users.currentUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LogEntryDayListWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/LogEntryDayListWidget.js
 **/